import React from 'react';
import { Modal } from '../ui/modal';
import Button from '../ui/button/Button';

interface DeleteAllConfirmationProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

const DeleteAllConfirmation: React.FC<DeleteAllConfirmationProps> = ({ isOpen, onClose, onConfirm }) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose} className="max-w-lg p-6">
            <div className="text-center">
                <div className="flex justify-center mb-4">
                    <div className="inline-flex items-center justify-center h-16 w-16 rounded-full bg-red-100 dark:bg-red-900/20">
                        <svg 
                            width="24" 
                            height="24" 
                            viewBox="0 0 24 24" 
                            fill="none" 
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path 
                                fillRule="evenodd" 
                                clipRule="evenodd" 
                                d="M7.85 2.75C7.85 1.7835 8.6335 1 9.6 1H14.4C15.3665 1 16.15 1.7835 16.15 2.75V4.75H18.8C19.736 4.75 20.5 5.514 20.5 6.45C20.5 7.386 19.736 8.15 18.8 8.15H5.2C4.264 8.15 3.5 7.386 3.5 6.45C3.5 5.514 4.264 4.75 5.2 4.75H7.85V2.75ZM9.6 2.75H14.4V4.75H9.6V2.75ZM5.2 9.45H18.8L18.062 20.047C17.9715 21.0685 17.1127 21.85 16.087 21.85H7.913C6.88725 21.85 6.0285 21.0685 5.938 20.047L5.2 9.45ZM10.35 11.75C10.35 11.3358 10.0142 11 9.6 11C9.1858 11 8.85 11.3358 8.85 11.75V18.85C8.85 19.2642 9.1858 19.6 9.6 19.6C10.0142 19.6 10.35 19.2642 10.35 18.85V11.75ZM14.4 11C14.8142 11 15.15 11.3358 15.15 11.75V18.85C15.15 19.2642 14.8142 19.6 14.4 19.6C13.9858 19.6 13.65 19.2642 13.65 18.85V11.75C13.65 11.3358 13.9858 11 14.4 11Z" 
                                fill="#DC2626" 
                                className="dark:fill-red-500"
                            />
                        </svg>
                    </div>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
                    Delete All Files
                </h3>
                <p className="text-gray-600 dark:text-gray-400 mb-6">
                    Are you sure you want to delete all files? This action cannot be undone and all your processed files will be permanently removed.
                </p>
                <div className="flex flex-col sm:flex-row justify-center gap-3">
                    <Button 
                        variant="outline" 
                        onClick={onClose}
                    >
                        Cancel
                    </Button>
                    <Button 
                        variant="primary" 
                        onClick={onConfirm}
                        className="bg-red-600 hover:bg-red-700 dark:bg-red-600 dark:hover:bg-red-700"
                    >
                        Delete All
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default DeleteAllConfirmation; 